import { z } from 'zod';

const LoginSchema = z.object({
  username: z
    .string()
    .min(1, 'Please enter your email address')
    .email('Please enter a valid email address'),
  password: z.string().min(1, 'Please enter your password').min(8),
});

type LoginSchemaType = z.infer<typeof LoginSchema>;

export type { LoginSchemaType };
export { LoginSchema };
